import React from 'react';
import { Link } from 'react-router-dom';

const HERO_CARDS = [
    { name: 'GenFinance', logo: require('../../../../images/landing-pages/partner/hero-section-icons/genfinance.png') },
    { name: 'ABF', logo: require('../../../../images/landing-pages/partner/hero-section-icons/abf.png') },
    { name: 'JPJenkins', logo: require('../../../../images/landing-pages/partner/hero-section-icons/jpj.png') },
    { name: 'Brown Rudnick', logo: require('../../../../images/landing-pages/partner/hero-section-icons/brown_rudnik.png') },
    { name: 'Fin-house', logo: require('../../../../images/landing-pages/partner/hero-section-icons/finhouse.png') },
    { name: 'Kiss the fish', logo: require('../../../../images/landing-pages/partner/hero-section-icons/kiss_the_fish.jpg') },
];

const PartnerHeroSection = () => (
    <section className="lp-partner-hero">
        <div className="lp-partner-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-partner-hero-inner">
            <div className="lp-partner-hero-copy">
                <div className="lp-partner-eyebrow" data-lp-reveal><span />Partner with Diligentsia</div>
                <h1 className="lp-partner-hero-h1" data-lp-reveal data-lp-delay="60">
                    Reach high-intent SMEs<br /><span>at exactly the right moment.</span>
                </h1>
                <p className="lp-partner-hero-lead" data-lp-reveal data-lp-delay="120">Your solution, shown to companies, CFOs, and investors at exactly the moment they need it.</p>
                <div className="lp-partner-hero-cta" data-lp-reveal data-lp-delay="180">
                    <a className="lp-btn lp-btn--primary" href="#cta">Become a partner</a>
                </div>
                <div className="lp-partner-hero-note" data-lp-reveal data-lp-delay="240"><span />Free listing · No upfront cost · Live in hours</div>
            </div>

            <div className="lp-partner-hero-art" data-lp-reveal data-lp-delay="200">
                <div className="lp-partner-hero-panel" aria-hidden="true" />
                <img className="lp-partner-hero-backdrop" src={require('../../../../images/landing-pages/partner/handshake.png')} alt="" aria-hidden="true" />
                <div className="lp-partner-appcard lp-float-anim">
                    <div className="bar">
                        <span className="dot" style={{ background: '#FF5F57' }} />
                        <span className="dot" style={{ background: '#FEBC2E' }} />
                        <span className="dot" style={{ background: '#28C840' }} />
                        <span className="ttl">Diligentsia AppStore</span>
                    </div>
                    <div className="grid">
                        {HERO_CARDS.map((c, i) => (
                            <div className="cell" key={i}>
                                <span className="tag">Partner</span>
                                <img src={c.logo} alt={c.name} />
                                <div className="nm">{c.name}</div>
                                <div className="more">More</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default PartnerHeroSection;
